import React from 'react';
import LabelWithSiblings from './label-with-siblings';

/**
 * Creates a MUI Switcher which has beside a label which has the "for" attribute set.
 * NOTE: the id of the checkbox gets overwritten!
 * @param labelContent
 * @param labelClassNames
 * @param switcherProps
 * @return {JSX.Element}
 * @see https://mui.com/material-ui/api/switch/ for the switcher props
 * @constructor
 */
function LabelWithSwitcher({ labelContent, tooltipContent, labelClassNames, ...switcherProps }) {
    return (
        <LabelWithSiblings
            siblingsMask={tooltipContent ? 'SLI' : 'SL'}
            labelContent={labelContent}
            labelClassNames={labelClassNames}
            tooltipContent={tooltipContent}
            {...switcherProps}
        />
    );
}

export default LabelWithSwitcher;
